// extracted by css-extract-rspack-plugin
export default {"symbol":"CurrencyPicker-module__symbol___QBrKs"};